import { createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0587e4b7")

_pushScopeId("data-v-0587e4b7")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("独自アプリを登録")
const _hoisted_2 = {
  key: 0,
  class: " w-3/4 mx-auto mb-6"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "p-3 mt-2 mx-2 bg-red-100 rounded-md text-sm leading-6" }, [
  /*#__PURE__*/_createTextVNode(" 独自アプリが非表示に設定されています。"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 表示するには、「この独自アプリをみんがくアプリの一覧から非表示にする」のチェックを外してください。 ")
], -1)
const _hoisted_4 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_5 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_6 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_7 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_8 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm font-medium text-gray-500" }, " みんがくアプリ内で独自アプリを表示 ※ チェックを外した場合は外部ブラウザで開きます ", -1)
const _hoisted_10 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_11 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_12 = {
  key: 1,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm font-medium text-gray-500" }, " 独自アプリを全教室の全生徒に表示する ", -1)
const _hoisted_14 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_15 = {
  key: 2,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_16 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm font-medium text-gray-500" }, " この独自アプリをみんがくアプリの一覧から非表示にする ", -1)
const _hoisted_18 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 独自アプリを登録 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_M_icon_file_input = _resolveComponent("M-icon-file-input")
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_ms_student_picker = _resolveComponent("ms-student-picker")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      (_ctx.isDisplayNone)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_M_icon_file_input, {
          label: "独自アプリのアイコン",
          "img-type": "icon",
          src: _ctx.src,
          "is-selection-active": _ctx.isIconSelectionActive,
          disabled: _ctx.isDisplayNone,
          onSelectionActiveChange: _cache[1] || (_cache[1] = ($event: any) => (
            _ctx.isIconSelectionActive = !_ctx.isIconSelectionActive
          )),
          onAdd: _ctx.addIcon,
          onDelete: _ctx.deleteIcon
        }, null, 8, ["src", "is-selection-active", "disabled", "onAdd", "onDelete"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_m_text_field, {
          label: "独自アプリの名称",
          name: "name",
          type: "text",
          value: _ctx.appName,
          disabled: _ctx.isDisplayNone,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.appName = $event))
        }, null, 8, ["value", "disabled"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_m_text_field, {
          label: "独自アプリのURL",
          name: "name",
          type: "text",
          value: _ctx.url,
          disabled: _ctx.isDisplayNone,
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.url = $event))
        }, null, 8, ["value", "disabled"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_m_text_field, {
          label: "独自アプリの表示順",
          name: "name",
          type: "number",
          value: String(_ctx.displayOrder),
          disabled: _ctx.isDisplayNone,
          onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.displayOrder = $event))
        }, null, 8, ["value", "disabled"])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _withDirectives(_createVNode("input", {
            id: "notification",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isWebView = $event)),
            type: "checkbox",
            disabled: _ctx.isDisplayNone,
            name: "notification",
            class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
          }, null, 8, ["disabled"]), [
            [_vModelCheckbox, _ctx.isWebView]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_m_text_field, {
          label: "独自アプリのカテゴリ（任意）",
          name: "name",
          type: "text",
          value: _ctx.serviceType,
          disabled: _ctx.isDisplayNone,
          onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.serviceType = $event))
        }, null, 8, ["value", "disabled"])
      ]),
      (!_ctx.isAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _hoisted_13,
            _createVNode("div", _hoisted_14, [
              _withDirectives(_createVNode("input", {
                id: "notification",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.toAll = $event)),
                type: "checkbox",
                name: "notification",
                class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
                disabled: _ctx.isDisplayNone,
                onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleToAllFlagChange && _ctx.handleToAllFlagChange(...args)))
              }, null, 40, ["disabled"]), [
                [_vModelCheckbox, _ctx.toAll]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isAdmin && !_ctx.toAll && !_ctx.isDisplayNone)
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            _createVNode(_component_ms_student_picker, {
              "default-student-ids": _ctx.studentIds,
              onUpdate: _ctx.onStudentsUpdated
            }, null, 8, ["default-student-ids", "onUpdate"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode("div", _hoisted_18, [
          _withDirectives(_createVNode("input", {
            id: "notification",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.isDisplayNone = $event)),
            type: "checkbox",
            name: "notification",
            class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
          }, null, 512), [
            [_vModelCheckbox, _ctx.isDisplayNone]
          ])
        ])
      ])
    ]),
    footer: _withId(() => [
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.registerMiniApp
      }, {
        default: _withId(() => [
          _hoisted_19
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
})